import React from 'react';
import { useContent } from '../../hooks/useContent';
import LoadingSpinner from '../common/LoadingSpinner';
import ErrorMessage from '../common/ErrorMessage';

const Team = () => {
    const { content, isLoading, isError, error, loadContentBySection } = useContent('team');

    // Get the team content data
    const teamData = content.length > 0 ? content[0].content_data : null;

    if (isLoading) {
        return (
            <section className="section team-area team-style-two overflow-hidden ptb_100">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <LoadingSpinner size="lg" />
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    if (isError) {
        return (
            <section className="section team-area team-style-two overflow-hidden ptb_100">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <ErrorMessage error={error} onRetry={() => loadContentBySection('team')} />
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    if (!teamData) {
        return (
            <section className="section team-area team-style-two overflow-hidden ptb_100">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <div className="text-center">
                                <p>No team content available.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    return (
        <section className="section team-area team-style-two overflow-hidden ptb_100">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 col-md-10 col-lg-8">
                        {/* Section Heading */}
                        <div className="section-heading text-center">
                            <h2 className="text-capitalize">{teamData.heading}</h2>
                            <p className="d-none d-sm-block mt-4">{teamData.headingText}</p>
                            <p className="d-block d-sm-none mt-4">{teamData.headingTexttwo}</p>
                        </div>
                    </div>
                </div>
                <div className="row">
                    {teamData.teamData && teamData.teamData.map((item, idx) => (
                        <div key={`t_${idx}`} className="col-12 col-sm-6 col-md-4 col-lg-3">
                            {/* Single Team */}
                            <div className="single-team text-center overflow-hidden m-2 m-lg-0">
                                {/* Team Thumb */}
                                <div className="team-thumb d-inline-block position-relative overflow-hidden">
                                    <img src={item.image} alt={item.name} />
                                    {/* Team Overlay */}
                                    <div className="team-overlay">
                                        <h4 className="team-name text-white">{item.name}</h4>
                                        <h5 className="team-post text-white mt-2 mb-3">{item.designation}</h5>
                                        {/* Team Icons */}
                                        <div className="team-icons">
                                            {item.socialLinks && Object.entries(item.socialLinks).map(([platform, link], iconIdx) => (
                                                <a key={`ti_${iconIdx}`} className="p-2" href={link}>
                                                    <i className={`fab fa-${platform}`} />
                                                </a>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Team;